module.exports = __webpack_public_path__ + "media/images/flag/cs-29246c19048cd954bbc42066753bb8ea.jpg";